import { Container, Row, Col } from 'react-bootstrap';
import './TermsAndConditions.css';
import { useTranslation } from 'react-i18next'


const TermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <Container className="user-list-container">
      <Row className="mb-3 align-items-center">
        <Col xs={12} md={12}>
          <h5>{t('terms_and_conditions')}</h5>
          <ol type='1'>
            <li>
              <h6>{t('tac1')}</h6>
              <ol>
                <li>{t('tac1_1')}</li>  
                <li>
                  <ol className="list-unstyled">
                    <li>{t('tac1_2')}</li>
                    <ol type="a">
                      <li>{t('tac1_2a')}</li>
                      <li>{t('tac1_2b')}</li>
                    </ol>
                  </ol>             
                </li>
              </ol>  
            </li>  

            <li>
              <h6>{t('tac2')}</h6>
              <ol>
                <li>{t('tac2_1')}</li>
                <li>{t('tac2_2')}</li>
                <li>{t('tac2_3')}</li>
                <li>{t('tac2_4')}</li>  
              </ol>
            </li>

            <li>
              <h6>{t('tac3')}</h6>
              <ol>
                <li>{t('tac3_1')}</li>
              </ol>
              
            </li>

            <li>
              <h6>{t('tac4')}</h6>
              <ol>
                <li>{t('tac4_1')}</li>
              </ol>
            </li>

            <li>
              <h6>{t('tac5')}</h6>
              <ol>
                <li>{t('tac5_1')}</li>
              </ol>
            </li>

            <li>
              <h6>{t('tac6')}</h6>
              <ol>
                <li>{t('tac6_1')}</li>
              </ol>
            </li>

            <li>
              <h6>{t('tac7')}</h6>
              <ol>
                <li>{t('tac7_1')}</li>
              </ol>
            </li>
          </ol>          

        </Col>
      </Row>
    </Container>
  );
};

export default TermsAndConditions;